import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleGroupsUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <path
          d="M34.747 28.395a5.395 5.395 0 005.398-5.397 5.395 5.395 0 00-5.398-5.398 5.395 5.395 0 00-5.398 5.398 5.395 5.395 0 005.398 5.397zm3.701 1.542h-.4a7.592 7.592 0 01-3.301.771 7.608 7.608 0 01-3.301-.77h-.4c-.724 0-1.416.138-2.05.39 1.326.648 3.422 2.42 3.422 4.863 0 2.11.12 4-1.72 4h10.989A2.314 2.314 0 0044 36.876V35.49a5.553 5.553 0 00-5.552-5.552z"
          fill="#CCC"
        />
        <path
          d="M21.253 28.395a5.395 5.395 0 005.398-5.397 5.395 5.395 0 00-5.398-5.398 5.395 5.395 0 00-5.398 5.398 5.395 5.395 0 005.398 5.397zm3.701 1.542h-.4a7.592 7.592 0 01-3.301.771 7.608 7.608 0 01-3.301-.77h-.4A5.553 5.553 0 0012 35.488v1.388a2.314 2.314 0 002.313 2.313h13.88a2.314 2.314 0 002.313-2.313V35.49a5.553 5.553 0 00-5.552-5.552z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgPicCircleGroupsUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleGroupsUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleGroupsUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
